import { Accordion } from '@vfde-brix/ws10/accordion';
import { closeAccordion } from './accordion';
import { trackFootnoteLink } from '@vfde-sails/tracking';

const FOOTNOTE_INITIALIZED = 'initialized';

const clickHandler = (accordion: Accordion, target: EventTarget | null) => {
    const { items } = accordion.getProperties();

    if (!target || !(target instanceof HTMLElement)) {
        return;
    }

    const index = +target.innerText - 1;
    const item = items[index];

    if (item) {
        trackFootnoteLink(target.parentNode?.childNodes[0].textContent || '');

        closeAccordion(accordion);

        accordion.toggleItemByIndex(index, true, true);
    }
};

export const initFootnotes = (accordion: Accordion | null) => {
    if (!accordion) {
        return;
    }

    const footnoteElements = document.getElementsByTagName('sup');

    for (const footnoteEl of footnoteElements) {
        if (footnoteEl.classList.contains(FOOTNOTE_INITIALIZED)) {
            continue;
        }

        footnoteEl.addEventListener('click', event => clickHandler(accordion, event.target));
        footnoteEl.classList.add(FOOTNOTE_INITIALIZED);
    }
};
